
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/case-studies",
      function () {
        return require("private-next-pages/living/case-studies/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/case-studies"])
      });
    }
  